const CHINA_CDN_URL = 'https://cdn.cn1.suitsupply.com'

export const CHINA_ENVS = ['cn_tst', 'cn_prd'] as const

export type ChinaEnvironment = (typeof CHINA_ENVS)[number]

export function isChinaEnvironment(
  env: string | undefined,
): env is ChinaEnvironment {
  return CHINA_ENVS.some((chinaEnv) => chinaEnv === env)
}

// Re-declare the same font-family names as @susu/ui/theme.css so China CDN
// sources take precedence over the global cdn.suitsupply.com @font-face rules.
export const CHINA_FONT_FACES = `
  @font-face {
    font-family: 'GT America';
    font-weight: 300;
    font-style: normal;
    src:
      url(${CHINA_CDN_URL}/fonts/gt-america/gt-america-standard-light.woff2) format('woff2'),
      url(${CHINA_CDN_URL}/fonts/gt-america/gt-america-standard-light.woff) format('woff');
    font-display: swap;
  }
  @font-face {
    font-family: 'GT America';
    font-weight: 400;
    font-style: normal;
    src:
      url(${CHINA_CDN_URL}/fonts/gt-america/gt-america-standard-regular.woff2) format('woff2'),
      url(${CHINA_CDN_URL}/fonts/gt-america/gt-america-standard-regular.woff) format('woff');
    font-display: swap;
  }
  @font-face {
    font-family: 'GT America';
    font-weight: 500;
    font-style: normal;
    src:
      url(${CHINA_CDN_URL}/fonts/gt-america/gt-america-standard-medium.woff2) format('woff2'),
      url(${CHINA_CDN_URL}/fonts/gt-america/gt-america-standard-medium.woff) format('woff');
    font-display: swap;
  }
  @font-face {
    font-family: 'susu-icons';
    src:
      url(${CHINA_CDN_URL}/fonts/susu-iconfont/susu-icons.woff2?ulsd) format('woff2'),
      url(${CHINA_CDN_URL}/fonts/susu-iconfont/susu-icons.woff?ulsd) format('woff'),
      url(${CHINA_CDN_URL}/fonts/susu-iconfont/susu-icons.ttf?ulsd) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }`
